<template>
  <div :class="$style.root">
    <ChatRoomStatusCircle :class="$style['root__circle']" :status="status" />
    <div>{{ chatRoomStatusString[status] }}</div>
  </div>
</template>

<script lang="ts" setup>
import { chatRoomStatusString } from '@/models/chatRoom/chatRoomStatus'
import ChatRoomStatusCircle from '@/components/molecules/ChatRoomStatusCircle.vue'
import type { ChatRoomStatus } from '@/types/schema.generated'

defineProps<{
  status: ChatRoomStatus
}>()
</script>

<style lang="scss" module>
.root {
  display: inline-flex;
  align-items: center;

  &__circle {
    margin-right: 4px;
  }
}
</style>
